
import React, { useRef, useState, useEffect } from "react";
import clsx from 'clsx';
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import useClasses from "../../useClasses";

const styles = (theme) => ({
    root: {
        maxWidth: 345,
    },
    media: {
        height: 0,
        paddingTop: '56.25%', // 16:9
    },
    expand: {
        transform: 'rotate(0deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
        padding: theme.spacing(1)
    },
    expandOpen: {
        transform: 'rotate(180deg)',
    },
});

export default function Description({ description, initExpand }) {
    const classes = useClasses(styles);
    const [expanded, setExpanded] = React.useState(initExpand);
    const textRef = useRef();
    const [overflowActive, setOverflowActive] = useState(false);
    const handleExpandClick = () => {
        setExpanded(!expanded);
    };

    function isOverflowActive(event) {
        if (!event) return
        return event.offsetWidth < event.scrollWidth;
    }

    useEffect(() => {
        if (isOverflowActive(textRef.current)) {
            setOverflowActive(true);
            return;
        }

        setOverflowActive(false);
    }, [isOverflowActive]);

    if (description === "") return ""
    return <Box display={"flex"} alignItems={expanded ? "end" : "center"}>
        <Typography variant="body2" color="textSecondary" noWrap={!expanded} ref={textRef} style={expanded ? { "whiteSpace": "pre-line", width: "100%" } : { width: "100%" }}>
            {description}
        </Typography>
        {overflowActive || expanded || initExpand ? <div>
            <IconButton
                className={clsx(classes.expand, {
                    [classes.expandOpen]: expanded,
                })}
                onClick={handleExpandClick}
                aria-expanded={expanded}
                aria-label="show more"
                size="small"
            >
                <ExpandMoreIcon />
            </IconButton>
        </div> : null}
    </Box>
}